export const ANONYMOUS = 'anonymous';
export const VONTRAVEL_ANONYMOUS = 'vontravel_anonymous';
